



































import {Component, Vue} from 'vue-property-decorator';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import {Getter} from 'vuex-class';
import {workspacesApi} from '@/workspaces/workspaces';
import TagsInput from '@/shared/components/TagsInput.vue';
import Toast from '@/shared/services/toast';

@Component({
	components: {
		TagsInput
	}
})
export default class InviteUser extends Vue {

	@Getter public currentWorkspace!: WorkspaceViewModel;

	public updateInProgress: boolean = false;
	public emails: string[] = [];

	private emailRegex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

	public validation(input: string) {
		if (this.emailRegex.test(input)) {
			return true;
		} else {
			Toast.showError(`This is not a valid email`);
			return false;
		}
	}

	public update(): void {
		if (this.updateInProgress) {
			return;
		}

		if (!this.hasEmailAddresses()) {
			Toast.showError('No valid email addresses added');
			return;
		}

		this.updateInProgress = true;
		workspacesApi.inviteUsers(this.emails, this.currentWorkspace.id)
			.then(() => {
				Toast.showSuccess(`Successfully invited to ${this.currentWorkspace.name}`);
				this.$emit('close', true);
			})
			.catch(err => {
				this.updateInProgress = false;
				Toast.showError(err.message);
			});
	}

	public hasEmailAddresses() {
		return this.emails.length > 0;
	}
}
